import TextArea from '../TextArea'

const MLTextArea = ({ formHandler, name, isRequired = true, defaultValue, maxLength = 1000 }) => {
    const { formValues, handleFormValues } = formHandler

    const handleValue = (value, valueName) => {
        handleFormValues(valueName, { value, isRequired, isError: false })
    }

    const handleMaxLength = (value) => {
        if (value.length > maxLength) {
            return value.substring(0, maxLength)
        }
        return value
    }




    return (
        <div className="col-12">
            <div className="row  text-area-container">
                <TextArea
                    label={name}
                    lang='Ar'
                    formHandler={formHandler}
                    isRequired={isRequired}
                    isError={formValues[name]?.isError}
                    defaultValue={defaultValue?.[name]}
                    name={name}
                    value={formValues[name]?.value || ''}
                    setValue={(value) => handleValue(handleMaxLength(value), name)}
                    className="col-md-6"

                    maxLength={maxLength}
                />
                <TextArea
                    formHandler={formHandler}
                    label={`${name}En`}
                    lang='En'
                    name={`${name}EN`}
                    defaultValue={defaultValue?.[`${name}EN`]}
                    isRequired={isRequired}
                    isError={formValues[`${name}En`]?.isError}
                    value={formValues[`${name}En`]?.value || ''}
                    setValue={(value) => handleValue(handleMaxLength(value), `${name}En`)}
                    className="col-md-6"
                    maxLength={maxLength}
                />
            </div>
        </div>

    )
}

export default MLTextArea